import RejectOrder from "../symbols/rejectOrder";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

function RejectOrderReducer(state = initialState, action: any) {
  switch (action.type) {
    case RejectOrder.REJECT_ORDER:
      return { ...state, loading: true, error: false };
    case RejectOrder.REJECT_ORDER_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case RejectOrder.REJECT_ORDER_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case RejectOrder.CLEAR_REJECT_ORDER:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default RejectOrderReducer;
